import React, { Component, forwardRef } from "react";

import EastIcon from "@mui/icons-material/East";
import "./Wheel.css";
import WheelCard from "./WheelCard";
import WheelVideoRing from "./WheelVideoRing";
import { ReactComponent as InProgess } from "../../../assets/Icons/books/work_in_progress.svg";
import { ReactComponent as InProgessDark } from "../../../assets/Icons/books/work_in_progress_light theme.svg";
import { useIsVideoTheme } from "../../Layout/ThemeBackground/ThemeBackground";

export class Wheel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      height: 380, //height of the wheel
      width: 380, //width of the wheel
      radius: 270, // radius from center of wheel
      // rotateCircle: false,
      centerItem: 0, //id of center element; element which is active.
      prevItem: 6, //left of center element
      nextItem: 1, //right of center element
      lastItem: 6, //id of last element (5)
      carouselDeg: 270, //starting degree
      itemDeg: 90, //card degree
      expand: false,
    };

    this.tempTheta = 0.0;
    this.appliedFocusBookId = null;
  }

  getStorageKey = () => {
    return this.props.storageKey || "wheelScroll";
  };

  getBooks = () => {
    return Array.isArray(this.props?.books) ? this.props.books : [];
  };

  getCenterBook = (books = this.getBooks(), centerItem = this.state.centerItem) => {
    if (!books.length) {
      return null;
    }

    const book = books[centerItem];
    return book?._id ? book : null;
  };

  notifyCenterItem = (centerItem = this.state.centerItem) => {
    const books = this.getBooks();
    if (!books.length) {
      this.props.getCenterItem?.(centerItem);
      return;
    }

    this.props.getCenterItem?.(centerItem);
  };

  resetWheelPosition = (callback) => {
    this.setState(
      {
        centerItem: 0,
        prevItem: 6,
        nextItem: 1,
        lastItem: 6,
        carouselDeg: 270,
      },
      callback,
    );
  };

  sanitizeStorageConfig = (config) => {
    if (!config) return config;
    const { activeBook, ...rest } = config;
    return rest;
  };

  buildCards = (books = []) => {
    return [
      { id: 0, position: 1, rotate: 90, ...(books?.[0] || {}) },
      { id: 1, position: 2, rotate: 143, ...(books?.[1] || {}) },
      { id: 2, position: 3, rotate: 195, ...(books?.[2] || {}) },
      { id: 3, position: 4, rotate: 244, ...(books?.[3] || {}) },
      { id: 4, position: 5, rotate: 297, ...(books?.[4] || {}) },
      { id: 5, position: 6, rotate: 347, ...(books?.[5] || {}) },
      { id: 6, position: 7, rotate: 400, ...(books?.[6] || {}) },
    ];
  };

  getPersistedState = () => {
    const { centerItem, prevItem, nextItem, lastItem, carouselDeg } = this.state;
    return { centerItem, prevItem, nextItem, lastItem, carouselDeg };
  };
  // Function to change center card to next card or in reverse.
  getIdItems = (side) => {
    // true = next, false = prev
    const { nextItem, prevItem, lastItem } = this.state;

    if (side) {
      this.setState(
        {
          centerItem: nextItem,
        },
        () => prevNext(this.state.centerItem),
      );
      this.props.getCenterItem && this.props.getCenterItem(nextItem);
    } else {
      this.setState(
        {
          centerItem: prevItem,
        },
        () => prevNext(this.state.centerItem),
      );
      this.props.getCenterItem && this.props.getCenterItem(prevItem);
    }

    const prevNext = (itemId) => {
      if (itemId === lastItem) {
        this.setState({
          nextItem: 0,
          prevItem: lastItem - 1,
        });
      } else if (itemId === 0) {
        this.setState({
          prevItem: lastItem,
          nextItem: 1,
        });
      } else {
        this.setState((state) => ({
          nextItem: state.centerItem + 1,
          prevItem: state.centerItem - 1,
        }));
      }
    };
    setTimeout(() => {
      const oldScrollConfig = JSON.parse(
        localStorage.getItem(this.getStorageKey()),
      );

      localStorage.setItem(
        this.getStorageKey(),
        JSON.stringify(
          this.sanitizeStorageConfig({
            ...(oldScrollConfig || {}),
            state: this.getPersistedState(),
          }),
        ),
      );
    }, 100);
  };

  /**
   *
   * @param {boolean} isUp
   */
  handleScroll = (isUp = true) => {
    const oldScrollConfig = JSON.parse(
      localStorage.getItem(this.getStorageKey()),
    );

    let isCardOpen = isUp || false;
    if (oldScrollConfig) {
      isCardOpen = oldScrollConfig?.isCardOpen;
    }
    localStorage.setItem(
      this.getStorageKey(),
      JSON.stringify(
        this.sanitizeStorageConfig({
          ...(oldScrollConfig || {}),
          isUp,
          isCardOpen: isCardOpen,
        }),
      ),
    );

  };

  // Handler functions that triggers rotation
  next = () => {
    this.getIdItems(true);
    this.setState((state) => ({
      carouselDeg: state.carouselDeg - 51.42857, // each next or previous button click will rotate the wheel by 360/7deg (circle's total angle/number of cards) = 51.42857
    }));
  };

  prev = () => {
    this.getIdItems(false);
    this.setState((state) => ({
      carouselDeg: state.carouselDeg + 51.42857, // each next or previous button click will rotate the wheel by 360/7deg (circle's total angle/number of cards) = 51.42857
    }));
  };

  // To determine type of card based on postion and for css styling.
  type = (id) => {
    const { centerItem, nextItem, prevItem } = this.state;

    if (id === centerItem) {
      return "active";
    } else if (id === nextItem) {
      return "next";
    } else if (id === prevItem) {
      return "prev";
    } else {
      return "not-active";
    }
  };

  selectedBookHandler = (id, itemRotation) => {
    let rotation;

    if (this.state.centerItem === 0 && 6 === id) {
      this.setState({
        carouselDeg: this.state.carouselDeg + 1 * 51.42857,
      });
    } else if (this.state.centerItem === 6 && 0 === id) {
      this.setState({
        carouselDeg: this.state.carouselDeg - 1 * 51.42857,
      });
    } else if (this.state.centerItem < id) {
      rotation = id - this.state.centerItem;
      this.setState({
        carouselDeg: this.state.carouselDeg - rotation * 51.42857,
      });
    } else {
      rotation = this.state.centerItem - id;
      this.setState({
        carouselDeg: this.state.carouselDeg + rotation * 51.42857,
      });
    }
    this.props.getCenterItem && this.props.getCenterItem(id);

    this.setState({
      centerItem: id,
      prevItem: id - 1,
      nextItem: id + 1,
    });
  };

  getNeighborItems = (id) => {
    const lastItem = this.state.lastItem;
    if (id === lastItem) {
      return { prevItem: lastItem - 1, nextItem: 0 };
    }
    if (id === 0) {
      return { prevItem: lastItem, nextItem: 1 };
    }
    return { prevItem: id - 1, nextItem: id + 1 };
  };

  persistWheelState = () => {
    const oldScrollConfig = JSON.parse(
      localStorage.getItem(this.getStorageKey()),
    );
    localStorage.setItem(
      this.getStorageKey(),
      JSON.stringify(
        this.sanitizeStorageConfig({
          ...(oldScrollConfig || {}),
          state: this.getPersistedState(),
        }),
      ),
    );
  };

  /**
   * Center the wheel on a book by id (absolute position from slot 0).
   * Used to land on the ongoing org book instead of localStorage/first book.
   */
  focusBookById = (bookId) => {
    if (!bookId) return false;
    const books = this.getBooks();
    const index = books.findIndex((book) => book?._id === bookId);
    if (index < 0) return false;

    const { prevItem, nextItem } = this.getNeighborItems(index);
    const carouselDeg = 270 - index * 51.42857;

    this.setState(
      {
        centerItem: index,
        prevItem,
        nextItem,
        carouselDeg,
      },
      () => {
        this.notifyCenterItem(index);
        this.persistWheelState();
      },
    );
    this.appliedFocusBookId = bookId;
    return true;
  };

  tryApplyFocusBookId = () => {
    const { focusBookId, isPreview } = this.props;
    if (isPreview || !focusBookId) return false;
    if (this.appliedFocusBookId === focusBookId) return true;
    return this.focusBookById(focusBookId);
  };

  handleExpand = () => {
    this.setState({
      expand: !this.state.expand,
    });
  };

  componentDidUpdate(prevProps) {
    const prevBooks = Array.isArray(prevProps.books) ? prevProps.books : [];
    const books = this.getBooks();

    if (prevProps.focusBookId !== this.props.focusBookId) {
      this.tryApplyFocusBookId();
    }

    if (prevBooks.length === books.length) {
      return;
    }

    if (!books.length) {
      this.resetWheelPosition(() => this.notifyCenterItem(0));
      return;
    }

    if (this.tryApplyFocusBookId()) {
      return;
    }

    if (this.state.centerItem >= books.length) {
      this.resetWheelPosition(() => this.notifyCenterItem(0));
    }
  }

  componentDidMount() {
    if (this.props.isPreview) return;
    const books = this.getBooks();
    const hasSeenWheelSwipeDemo = JSON.parse(
      localStorage.getItem("know_swipe"),
    );

    if (!hasSeenWheelSwipeDemo) {
      let wheel = document.getElementById("wheel");
      if (wheel) {
        wheel.classList.add("bounce");
      }
    }
    const rawScrollConfig = JSON.parse(
      localStorage.getItem(this.getStorageKey()),
    );
    const oldScrollConfig = this.sanitizeStorageConfig(rawScrollConfig);

    if (rawScrollConfig?.activeBook) {
      localStorage.setItem(
        this.getStorageKey(),
        JSON.stringify(oldScrollConfig),
      );
    }

    if (oldScrollConfig?.isUp) {
      this.handleScroll(true);
    }

    if (!books.length) {
      this.resetWheelPosition(() => this.notifyCenterItem(0));
    } else if (this.tryApplyFocusBookId()) {
      // Ongoing book takes priority over restored localStorage position.
    } else if (oldScrollConfig?.state) {
      this.setState({ ...oldScrollConfig.state }, () => {
        this.notifyCenterItem(this.state.centerItem);
      });
    } else {
      this.notifyCenterItem(this.state.centerItem);
    }
    this.layoutScrollEl = document.getElementById("layout");
    if (this.layoutScrollEl) {
      this.layoutScrollEl.addEventListener(
        "scroll",
        this.handleScrollStateToggle,
      );
    }
  }

  handleScrollStateToggle = () => {
    localStorage.setItem("know_swipe", JSON.stringify(true));
    let wheel = document.getElementById("wheel");
    if (wheel) {
      wheel?.classList.remove("bounce");
    }
    const layoutEl = document.getElementById("layout");
    if (!layoutEl) return;
    const scrollTop = layoutEl.scrollTop;
    const oldScrollConfig = JSON.parse(
      localStorage.getItem(this.getStorageKey()),
    );
    if (scrollTop === 0) {
      localStorage.setItem(
        this.getStorageKey(),
        JSON.stringify(
          this.sanitizeStorageConfig({
            ...(oldScrollConfig || {}),
            isUp: false,
          }),
        ),
      );
    } else {
      localStorage.setItem(
        this.getStorageKey(),
        JSON.stringify(
          this.sanitizeStorageConfig({
            ...(oldScrollConfig || {}),
            isUp: true,
          }),
        ),
      );
    }
  };

  componentWillUnmount() {
    this.layoutScrollEl?.removeEventListener(
      "scroll",
      this.handleScrollStateToggle,
    );
  }

  render() {
    const books = this.getBooks();
    const cards = this.buildCards(books);
    const centerBook = this.getCenterBook(books, this.state.centerItem);
    const hasCenterBook = Boolean(centerBook);
    return (
      <div
        className={
          this.props.isPreview ? "quest__prevwheellayout" : "quest__wheellayout"
        }
        id="wheel"
      >
        <div
          ref={(ref_id) => (this.wheel = ref_id)}
          style={{
            border: this.props.isVideoTheme
              ? "185px solid transparent"
              : `185px solid ${
                  this.props.isPreview
                    ? this.props.prevWheelBg
                    : this.props.wheelBgColor
                }`,
            transform: `rotate(${this.state.carouselDeg}deg)`,
            // top: this.props.isExpanded ? `81%` : `100%`,
          }}
          className={this.props.isVideoTheme ? "wheel wheel--video" : "wheel"}
        >
          {this.props.isVideoTheme ? (
            <WheelVideoRing rotation={this.state.carouselDeg} />
          ) : null}
          {/* <Button onClick={this.handleExpand}>Hello</Button> */}
          {/* {this.state.cards}\ */}
          {cards.map((item, i) => {
            let centerOfWheel = {
              x: parseFloat(this.state.width / 2.0),
              y: parseFloat(this.state.height / 2.0),
            };
            return (
              <WheelCard
                type={this.type(i)}
                itemRotation={item.rotate}
                theta={((Math.PI * 2) / 7.0) * i}
                radius={this.state.radius}
                center={centerOfWheel}
                key={item.id}
                id={item.id}
                selectedBookHandler={this.selectedBookHandler}
                name={item.name}
                handleClick={() => this.handleRotate(i)}
                bookData={this.props?.books}
                prevFunc={this.prev}
                nextFunc={this.next}
                startHandler={this.props.startHandler}
                isPreview={this.props.isPreview}
                activeTab={this.props.activeTab}
                isExpanded={this.props.isExpanded}
                coverImage={item.coverImage}
                wheelImage={item.wheelImage}
                bookType={item.type}
                isLocked={item.isLocked}
                isPublished={item.isPublished}
              />
            );
          })}
        </div>
        <div
          className={
            this.props.isPreview
              ? "quest__prevcurrentPreview"
              : "quest__current"
          }
          style={{
            transition: "0.4s ease-in-out",
            width: "max-content",
          }}
        >
          <div className="step22">
            <div className="quest__wheelcenter">
              {/* Points card */}
              {/* <div className="quest__topcard">
              <img
                src={CoinsSvg}
                style={{
                  height: "35px",
                }}
                alt=""
              />

              <h3>{this.props.activeBook?.points || 0} Points</h3>
            </div> */}
              {/* Center card */}
              <div
                className="quest__card"
                // ${this.props.themeCardImage}
                style={{
                  zIndex: 22,
                  background:
                    this.props.wheelColors?.length === 2
                      ? `linear-gradient(to right, ${this.props.wheelColors[0]} , ${this.props.wheelColors[1]})`
                      : this.props.wheelColors
                        ? this.props.wheelColors[0]
                        : "",
                }}
              >
                <div className="ftwt__b ">
                  {hasCenterBook ? (
                    <div
                      className="ftwt__b "
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "2px",
                        // width: '200px',
                        maxWidth: "250px",
                      }}
                    >
                      <h4 className="ftwt__b truncate1">
                        {centerBook?.order && centerBook?.order + ". "}
                        {centerBook?.name}
                      </h4>
                    </div>
                  ) : (
                    <>
                      <InProgess
                        className="quest__centerProgess"
                        style={{ height: "30px" }}
                      />
                      <InProgessDark
                        className="quest__centerProgessDark"
                        style={{ height: "30px" }}
                      />
                      <h4
                        style={{ marginTop: "10px" }}
                        className="ftwt__b truncate1"
                      >
                        Work In Progess
                      </h4>
                    </>
                  )}
                </div>
                <h6
                  className="ftwt__r truncate-4"
                  // style={{ lineBreak: "anywhere" }}
                >
                  {hasCenterBook ? centerBook?.description || "" : ""}
                </h6>
                {hasCenterBook ? (
                  <>
                    <button
                      onClick={() =>
                        this.props.startHandler(
                          centerBook?._id,
                          centerBook?.isLocked,
                        )
                      }
                      className="contained__lgbtn2 home__zoom"
                      style={{ fontWeight: "600" }}
                    >
                      Let's Start <EastIcon sx={{ fontSize: "18px" }} />
                    </button>
                    <div
                      style={{
                        marginTop: "25px",
                      }}
                      id="scroll-pivot"
                    ></div>
                  </>
                ) : null}
              </div>
              <div className="card__arrow">
                <style>
                  {`
                .card__arrow::before {
                  content: "";
                  position: absolute;
                  top: -13px;
                  left: 188px;
                  transform: translateX(-50%);
                   border-left: 18px solid transparent;
                  border-right: 18px solid transparent;
                  border-bottom: 18px solid ${
                    this.props.wheelColors ? this.props.wheelColors[0] : ""
                  }; 
                }
                `}
                </style>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const WheelWithTheme = forwardRef(function WheelWithTheme(props, ref) {
  const isVideoTheme = useIsVideoTheme();
  return <Wheel {...props} ref={ref} isVideoTheme={isVideoTheme} />;
});

export default WheelWithTheme;
